module.exports = __webpack_public_path__ + "img/46.36636bf5.png";